import { AccordionCollapse, AccordionItem, AccordionToggle, } from '@awaze/design-system.components.accordion/';
import { IconButton } from '@awaze/design-system.components.button';
import { breakpoints } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
export const MobileOverlayStyled = styled.div `
  position: fixed;
  background: white;
  width: auto;
  height: 100vh;
  z-index: 10;
  top: 0px;
  overflow: auto;
  left: 0px;
  padding: ${({ showMegaMenu }) => showMegaMenu ? '20px 16px 100px 16px' : '20px 16px'};
  right: 0px;
  transform: translate(0, 0);
  opacity: 1;
  transition: transform 200ms ease-in, opacity 200ms ease-out;

  ${({ isOpen }) => !isOpen &&
    css `
      opacity: 0;
      user-select: none;
      pointer-events: none;
      transform: translate(100vw, 0);
      transition: transform 200ms ease-in, opacity 200ms ease-out;
    `}

  // Burger-Menu overlay List-Items style
  & > nav > ul > li > ul > li {
    padding: 0;
    margin: 0;
  }

  & > nav > ul {
    gap: 0;
  }

  & > nav > ul > li {
    border-bottom: 1px solid ${({ theme }) => theme.ColorGrey100};
    padding-top: 6px;
    padding-bottom: 18px;
    margin-bottom: 18px;

    &:last-child {
      border-bottom: none;
    }
  }
`;
export const RemoveScrollStyled = styled.div `
  @media screen and (min-width: ${({ showMegaMenu }) => showMegaMenu ? '1220px' : `${breakpoints[0]}px`}) {
    display: none;
  }
`;
export const AccordionItemStyled = styled(AccordionItem) `
  color: ${({ theme }) => theme.ColorTextBodyOnWhite};
  border-top: none;

  span > svg {
    fill: ${({ theme }) => theme.ColorGrey500};
  }

  &:first-child {
    @media (min-width: ${breakpoints[1]}px) {
      border-top: none;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;
export const AccordionCollapseStyled = styled(AccordionCollapse) `
  padding: 0 16px 0;
`;
export const AccordionToggleStyled = styled(AccordionToggle) `
  padding: 6px 0;
`;
export const IconButtonStyled = styled(IconButton) `
  position: absolute;
  top: 12px;
  right: 8px;
  z-index: 10;
`;
//# sourceMappingURL=mobile-menu.styles.js.map